import {
  setLocation,
  setDates,
} from '../ducks/requestDuck';
import { HOTEL, RECENT_SEARCHES } from '../constants/smartfillConstants';

const setLocationOnChangeThunk = (value) => async (dispatch) => {
  if (value?.type === RECENT_SEARCHES) {
    dispatch(setLocation({
      ...value,
      type: HOTEL,
    }));
    dispatch(setDates(value.dates));
  } else {
    dispatch(setLocation(value));
  }
};

export { setLocationOnChangeThunk };
